import { getCountryByCode, INTERNATIONAL_CODE } from '../data/countries';

/**
 * Apply country filter to a Supabase query builder.
 * Uses country_of_origin / location text fields (works before & after migration).
 */
export function applyCountryFilter(query, countryCode, { table = 'companies', includeInternational = true } = {}) {
  if (!countryCode || countryCode === INTERNATIONAL_CODE) return query;

  const country = getCountryByCode(countryCode);
  const name = country.name;

  if (table === 'companies') {
    if (includeInternational) {
      // Include major multinationals + country-specific matches
      return query.or(`country_of_origin.ilike.%${name}%,headquarters.ilike.%${name}%`);
    }
    return query.or(`country_of_origin.ilike.%${name}%,headquarters.ilike.%${name}%`);
  }

  if (table === 'user_profiles') {
    return query.or(`location.ilike.%${name}%`);
  }

  if (table === 'political_action_committees') {
    return query.or(`headquarters_location.ilike.%${name}%,pac_name.ilike.%${name}%`);
  }

  if (table === 'research_queue') {
    return query.ilike('notes', `%[${country.name}]%`);
  }

  return query;
}

export function getStoredLocalePrefs() {
  try {
    const raw = localStorage.getItem('wymr_locale_prefs');
    if (raw) return JSON.parse(raw);
  } catch (_) {}
  return { countryCode: INTERNATIONAL_CODE, includeInternational: true, language: 'en' };
}
